import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Alert,
} from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import HubIcon from "@mui/icons-material/Hub";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const OverviewTab = () => (
  <Card>
    <CardContent>
      <Typography variant="h5" gutterBottom>
        Ticket automation with PlentyOne and n8n
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Sync customer tickets from PlentyOne, review conversations in the
        dashboard, and use n8n to draft AI replies. Human review stays in the UI
        — approved replies are sent directly to Plenty from the backend.
      </Typography>

      <Grid container spacing={3} mt={2}>
        <Grid item xs={12} md={4}>
          <Card variant="outlined">
            <CardContent sx={{ textAlign: "center" }}>
              <SupportAgentIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">PlentyOne Integration</Typography>
              <Typography variant="body2" color="text.secondary">
                Fetch and sync tickets, messages, and attachments from PlentyOne
                with scheduled refresh and manual sync.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card variant="outlined">
            <CardContent sx={{ textAlign: "center" }}>
              <HubIcon color="success" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">n8n Workflows</Typography>
              <Typography variant="body2" color="text.secondary">
                Trigger n8n to generate draft replies from ticket context.
                Configure prompts and AI logic in your workflow builder.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card variant="outlined">
            <CardContent sx={{ textAlign: "center" }}>
              <AutoAwesomeIcon color="info" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">Human in the loop</Typography>
              <Typography variant="body2" color="text.secondary">
                Edit drafts, set recipient and reference, toggle whisper, then
                send when ready. Ticket status tracks progress from TODO to
                completed.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom>
        Getting started
      </Typography>
      <ol style={{ paddingLeft: "20px" }}>
        <li>
          <strong>Plenty credentials:</strong> Add active PlentyOne login
          credentials under Credentials.
        </li>
        <li>
          <strong>n8n workflow:</strong> Open Credentials → n8n Workflow and
          enter the webhook URL, token, and callback URL.
        </li>
        <li>
          <strong>Process tickets:</strong> Expand a ticket, trigger generate,
          review and edit the draft, then click Send to Plenty.
        </li>
      </ol>

      <Alert severity="info" sx={{ mt: 3 }}>
        n8n receives ticket and message context on generate. It should POST back
        with <code>action: generate_complete</code> to persist the draft.
        Sending uses <code>POST /rest/messages</code> via active Plenty
        credentials — not n8n.
      </Alert>
    </CardContent>
  </Card>
);

export default OverviewTab;
